
define('text!common/views/discussion/comment-count--content-immersive.html',[],function () { return '<a href="<%=url%>" data-link-name="Comment count" class="commentcount2 tone-colour">\n    <%=icon%><span class="commentcount__value"><%=count%></span> Comments\n</a>\n';});

